import { useContext, type ReactElement } from 'react'

import type { TypeSectionGroupEntry } from '@contentful-types/section-group'

import { SectionContext } from '@contexts/section-context'

import { GroupPageSection } from '@components/page-core/section-group/group'
import { SectionRenderer } from '@components/renderer'
import { GroupTabSection } from '@components/tab/tab-group-section'

export function SectionGroupContent({ data }: { data: TypeSectionGroupEntry }): ReactElement {
  const {
    fields: { heading, rows },
  } = data

  const { isHero, indexInPage } = useContext(SectionContext)

  const [firstSection, ...otherSections] = rows || []

  return (
    <>
      <SectionRenderer
        isHero={isHero}
        isH1Section={isHero && !heading?.fields?.title}
        isGrouped
        hasGroupHeading={!!heading}
        data={firstSection}
        startIndexInPage={indexInPage}
      />
      <SectionRenderer
        isGrouped
        hasGroupHeading={!!heading}
        data={otherSections}
        startIndexInPage={indexInPage && indexInPage + 1}
      />
    </>
  )
}

export function SectionGroup({
  className,
  data,
}: {
  className?: string
  data: TypeSectionGroupEntry
}): ReactElement {
  const {
    sys,
    fields: { internalName, heading, background },
  } = data

  const { sectionGroupSwoosh } = useContext(SectionContext)

  return (
    <GroupPageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      heading={heading}
      background={background}
      sectionGroupSwoosh={sectionGroupSwoosh}
    >
      <SectionGroupContent data={data} />
    </GroupPageSection>
  )
}

export const SectionGroupForTabs = ({
  className,
  data,
}: {
  className?: string
  data: TypeSectionGroupEntry
}) => {
  const {
    fields: { heading, background },
  } = data

  const { sectionGroupSwoosh } = useContext(SectionContext)

  return (
    <GroupTabSection
      className={className}
      heading={heading}
      background={background}
      sectionGroupSwoosh={sectionGroupSwoosh}
    >
      <SectionGroupContent data={data} />
    </GroupTabSection>
  )
}
